(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const heroVideos = document.querySelectorAll('.hero-video-wrapper .hero-video');

    heroVideos.forEach((video) => {
      const wrapper = video.closest('.hero-video-wrapper');
      const poster = wrapper && wrapper.dataset.poster;

      if (poster) {
        video.setAttribute('poster', poster);
      }

      video.setAttribute('controlsList', 'nodownload nofullscreen');
      video.setAttribute('disablePictureInPicture', '');
      video.playsInline = true;
      video.controls = false;
    });

    // IntersectionObserver for video autoplay/pause optimization
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            // Video is in viewport, play it
            video.play().catch((error) => {
              console.warn('Video autoplay failed:', error);
            });
          } else {
            // Video is out of viewport, pause it
            video.pause();
          }
        });
      }, {
        threshold: 0.5 // Play when 50% of video is visible
      });

      heroVideos.forEach((video) => {
        videoObserver.observe(video);
      });
    }

    const ctaButtons = document.querySelectorAll('.hero-section .btn');

    ctaButtons.forEach((button) => {
      button.addEventListener('click', function() {
        // Shopify analytics tracking with error handling
        try {
          if (typeof window !== 'undefined' && window.Shopify && window.Shopify.analytics) {
            window.Shopify.analytics.publish('hero_cta_click', {
              button_type: this.classList.contains('btn-primary') ? 'primary' : 'secondary',
              button_text: this.textContent.trim(),
            });
          }
        } catch (error) {
          console.warn('Shopify analytics tracking failed:', error);
        }

        // Klaviyo tracking with error handling
        try {
          if (typeof klaviyo !== 'undefined' && typeof klaviyo.push === 'function') {
            klaviyo.push([
              'track',
              'Hero CTA Clicked',
              {
                'Button Type': this.classList.contains('btn-primary') ? 'primary' : 'secondary',
                'Button Text': this.textContent.trim(),
                'Page URL': window.location.href,
              },
            ]);
          }
        } catch (error) {
          console.warn('Klaviyo tracking failed:', error);
        }
      });
    });
  });
})();
